  import { Component, Input, OnInit } from '@angular/core';

  @Component({
    selector: 'app-new-ai-suggestion',
    templateUrl: './new-ai-suggestion.component.html',
    styleUrls: ['./new-ai-suggestion.component.scss']
  })
  export class NewAiSuggestionComponent implements OnInit {

    @Input() OrderId: any;
    @Input() IndentNo: any;

    LowestRatesData = [
  {
    type: 'Self Fulfilled',
    vehicleImage: '',
    transporter: 'Delivery Surface',
    remark: 'Driver available nearby',
    isBestPrice: true,
    price: 520,
    vehicleNo: 'MH04 AB 3232',
    driver: 'Austin Thurston',
    rating: 4.3,
    nearestLocation: 'Andheri East, Mumbai'
    // timing can be calculated live
  },
  {
    type: 'Contracted',
    isBestPrice: false,
    transporterLogo: '',
    transporter: 'Sharma Transport Co.',
    workingSince: '1998',
    email: 'ops@sharmatransport.com',
    mobile: '+91 91234 56789',
    noOfTripsDone: '1,284',
    office: 'MIDC, Andheri East',
    city: 'Mumbai',
    state: 'Maharashtra',
    availableDate: 'Today',
    remark: 'Preferred for regular lanes',
    price: 1450,
    rating: 4.6
  },
  {
    type: 'Bidding - L1',
    isBestPrice: false,
    transporterLogo: '',
    transporter: 'Patel Roadways',
    workingSince: '2009',
    email: 'bids@patelroadways.in',
    mobile: '+91 98765 43210',
    noOfTripsDone: '842',
    office: 'Bhiwandi Transport Hub',
    city: 'Bhiwandi',
    state: 'Maharashtra',
    availableDate: 'Tomorrow',
    remark: 'Lowest bidder for this route',
    price: 1380,
    rating: 4.2
  },
  {
    type: 'Historical Rate',
    isBestPrice: false,
    transporterLogo: '',
    transporter: 'Express Logistics Pvt Ltd',
    workingSince: '2001',
    email: 'support@expresslogistics.com',
    mobile: '+91 90123 45678',
    noOfTripsDone: '2,315',
    office: 'Narol, Ahmedabad',
    city: 'Ahmedabad',
    state: 'Gujarat',
    availableDate: 'N/A',
    remark: 'Based on last 3 similar trips',
    price: 1100,
    rating: 4.1,
    location: 'Mumbai',
    timing: '2 – 3 days'
  }
];


    constructor() {}

    ngOnInit(): void {}
  }
